import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'

export async function getBrands(queryParamString){
    const queryString = queryParamString || ''
    let results = ''
    try {
        results = await axios.get(`${DATAMASTER_ENDPOINT}/brands${queryString}`)
    } catch (error) {
        results = error.message
    }
    return results
}